import { useState } from "react";
import pointInPolygon from 'point-in-polygon-hao';

const PostcodeSearch = ({ goToConstituency, boundaries, idKey, boundaryType = 'constituency' }) => {
    const [postcode, setPostcode] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    const handleSearch = async (e) => {
        e.preventDefault();
        const cleanedPostcode = postcode.trim().replace(/\s/g, "").toUpperCase();
        if (!cleanedPostcode) return;

        setLoading(true);
        setError(false);

        const tryLookup = async (code, isOutcode = false) => {
            const endpoint = isOutcode ? 'outcodes' : 'postcodes';
            const response = await fetch(`https://api.postcodes.io/${endpoint}/${code}`);
            const data = await response.json();
            return data.status === 200 ? data.result : null;
        };

        try {
            // Try full postcode lookup first
            let result = await tryLookup(cleanedPostcode);

            // If that fails and it's short, try as an outcode
            if (!result && cleanedPostcode.length <= 4) {
                result = await tryLookup(cleanedPostcode, true);
            }

            if (result) {
                const { longitude, latitude } = result;
                const point = [longitude, latitude];

                const foundBoundary = boundaries.features.find(feature => {
                    if (!feature || !feature.geometry) return false;
                    const { type, coordinates } = feature.geometry;
                    if (type === "Polygon") {
                        return pointInPolygon(point, coordinates);
                    } else if (type === "MultiPolygon") {
                        return coordinates.some(polygon => pointInPolygon(point, polygon));
                    }
                    return false;
                });

                if (foundBoundary) {
                    goToConstituency(foundBoundary.properties);
                    setPostcode("");
                    setError(false);
                } else {
                    setError(true);
                }
            } else {
                setError(true);
            }
        } catch (err) {
            console.error("Postcode search error:", err);
            setError(true);
        } finally {
            setLoading(false);
        }
    };

    const handleInputChange = (e) => {
        setPostcode(e.target.value.toUpperCase());
    };

    return (
        <section className="postcode-search-section">
            <p id="postcode-search-label">Search by Postcode</p>
            <form onSubmit={handleSearch} style={{ position: 'relative' }}>
                <input
                    id="postcode-search-box"
                    type="text"
                    placeholder="e.g. SW1A 1AA or SW1A"
                    onChange={handleInputChange}
                    value={postcode}
                />
                <button
                    type="submit"
                    disabled={loading}
                    style={{
                        position: 'absolute',
                        right: '5px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        background: '#265089',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        padding: '4px 8px',
                        color: 'white',
                        fontSize: '12px'
                    }}
                >
                    {loading ? '...' : 'Go'}
                </button>
            </form>
            {error && <p style={{ color: '#ff6b6b', fontSize: '12px', marginTop: '4px' }}>Postcode not found or outside coverage.</p>}
        </section>
    );
};

export default PostcodeSearch;
